import { ERROR_NOT_FOUND_API } from 'constant/textNotification';

const useHandleError = () => {
  const messageError = async (res: any, errorNotification: any) => {
    const messError =
      res?.data &&
      (res?.data?.message ||
        res?.data?.Message ||
        res?.data?.errMessage ||
        res?.data?.errorMassage ||
        JSON.parse(await res.data.text()).Message);
    if (messError) {
      errorNotification(messError);
    } else if (res?.status === 404) {
      errorNotification(ERROR_NOT_FOUND_API);
    }
  };
  return {
    messageError,
  };
};

export default useHandleError;
